// Namespaced because connected_apps.id is client-supplied, so a bare "managed"
// could collide with a real connector id in connector_usage_daily.
export const MANAGED_AI_CONNECTOR_ID = "3b:managed-ai";
export const MANAGED_AI_CONNECTOR_LABEL = "Managed by 3B";

// The proxy registers one managed connector per provider and meters usage under
// that per-provider id (`3b:managed-ai:anthropic`, `…:openai`,
// `…:bedrock-anthropic`), so ledger readers must match the base sentinel and any
// provider-suffixed variant.
export function isManagedAiConnectorId(connectorId: string): boolean {
  return (
    connectorId === MANAGED_AI_CONNECTOR_ID ||
    connectorId.startsWith(`${MANAGED_AI_CONNECTOR_ID}:`)
  );
}

// The provider suffix of a managed connector id, or null for the base sentinel.
export function managedAiProviderFromConnectorId(
  connectorId: string
): string | null {
  const prefix = `${MANAGED_AI_CONNECTOR_ID}:`;
  return connectorId.startsWith(prefix)
    ? connectorId.slice(prefix.length)
    : null;
}

// Collapse every per-provider managed id onto the base sentinel so managed AI
// aggregates as a single connector rather than one row per provider.
export function canonicalManagedConnectorId(connectorId: string): string {
  return isManagedAiConnectorId(connectorId)
    ? MANAGED_AI_CONNECTOR_ID
    : connectorId;
}
